import React from 'react';
import PropTypes from 'prop-types';
import BallInfo from '../BallInfo';

const removeOverFromDescription = desc => {
  const indexOfColon = desc.indexOf(':');

  if (typeof desc !== 'string') {
    return '';
  }
  if (desc.length < 8) {
    return desc;
  }
  if (indexOfColon > 0 && indexOfColon < 7) {
    const overBallData = desc.substr(0, indexOfColon).split('.');
    const over = overBallData[0];
    const ball = overBallData[1];
    return {
      newdes: desc.substr(indexOfColon + 1),
      ball,
      over,
    };
  }
  return desc;
};

class CricketItem extends React.Component {
  render() {
    const {
      timestamp,
      wicket,
      scored,
      totalRuns,
      totalWickets,
      runs,
      description,
      smalldesc,
    } = this.props.data;
    let overs = '';
    let balls = '';
    let newdesc = '';
    const { battingTeam } = this.props;
    const matchDetails = removeOverFromDescription(smalldesc);
    if (typeof matchDetails === 'object') {
      ({ over: overs, ball: balls, newdes: newdesc } = matchDetails);
    } else {
      newdesc = matchDetails;
    }
    const ballsByOver =
      overs && parseInt(overs, 10) >= 0 && `${overs}.${balls}`;
    return (
      <div key={timestamp}>
        {/* {overs &&
          parseInt(overs, 10) >= 0 && <h6> {`${overs}.${balls}`} overs</h6>} */}
        {totalRuns !== '' &&
          totalRuns >= 0 && (
            <BallInfo
              runs={runs}
              description={description}
              teamName={battingTeam}
              totalRuns={totalRuns}
              totalWickets={totalWickets}
              scored={scored}
              wicket={wicket}
              overs={ballsByOver}
            />
          )}
        {newdesc && <p dangerouslySetInnerHTML={{ __html: newdesc }} />}
      </div>
    );
  }
}

CricketItem.propTypes = {
  data: PropTypes.shape({
    timestamp: PropTypes.number,
    wicket: PropTypes.number,
    scored: PropTypes.number,
    totalRuns: PropTypes.string,
    totalWickets: PropTypes.string,
    runs: PropTypes.string,
    description: PropTypes.string,
    smalldesc: PropTypes.string,
  }).isRequired,
  battingTeam: PropTypes.string.isRequired,
};

export default CricketItem;
